import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:matchId" element={<Home />} />
        <Route path="/court/:court" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
